<template>
  <base-wrapper>
    <div class="space-y-4">
      <div class="flex justify-end gap-2">
        <base-select
          :expand="false"
          :shadow="false"
          :options="[
            {
              key: 'all',
              label: 'Status',
              value: 'Diproses Gudang Pengeluaran,Persiapan',
            },
            {
              key: 'draft',
              label: 'Diproses Gudang Pengeluaran',
              value: 'Diproses Gudang Pengeluaran',
            },
            { key: 'valid', label: 'Persiapan', value: 'Persiapan' },
          ]"
          v-model="filter.status"
          @change="loadOrders"
        />
        <base-input
          type="search"
          :shadow="false"
          placeholder="Cari Kode"
          debounce
          v-model="filter.search"
          @native-input="loadOrders"
        />
      </div>

      <datatable
        :scroll-x="false"
        :columns="[
          { id: 'code', name: 'Nomor Faktur' },
          { id: 'destination_office_code', name: 'Kode Stockist' },
          { id: 'destination_office_name', name: 'Nama Pemilik' },
          { id: 'warehouse', name: 'Kode Gudang' },
          { id: 'area', name: 'Wilayah Harga' },
          {
            id: 'total_price',
            name: 'Total Penjualan',
            theadClass: 'text-right',
          },
          {
            id: 'warehouse_status',
            name: 'Status Pengeluaran',
            theadClass: 'text-center',
          },
        ]"
        :total="orders.meta.page.total"
        :perPage="orders.meta.page.perPage"
        :currentPage="orders.meta.page.currentPage"
        :meta="orders.meta"
        cursor
        @pagechanged="onPageChange"
      >
        <template #tbody="{ classes }">
          <tr
            v-for="(order, index) in orders.data"
            :key="index"
            :class="[classes.tr, 'cursor-pointer bg-white hover:bg-green-100']"
            @click="
              $router.push({
                name: 'gudang.pengeluaran.restock-barang-ke-stockist-diambil.detail',
                params: { id: order.relationships.order.data.id },
              })
            "
          >
            <td :class="[classes.td, 'space-y-1']">
              <p class="font-bold text-gray-900">
                {{ order.attributes.origin_code }}
              </p>
              <p class="text-xs text-gray-500">
                {{ order.attributes.updatedAt | formatDate }}
              </p>
            </td>
            <td :class="classes.td">
              {{
                getSingleIncluded(
                  orders,
                  order.relationships['destination-office'].data.id
                ).attributes.code
              }}
            </td>
            <td :class="classes.td">
              {{
                getSingleIncluded(
                  orders,
                  order.relationships['destination-office'].data.id
                ).attributes.name
              }}
            </td>
            <td :class="classes.td">
              {{
                getSingleIncluded(
                  orders,
                  order.relationships['destination-warehouse'].data.id
                ).attributes.code
              }}
              /
              {{
                getSingleIncluded(
                  orders,
                  order.relationships['origin-warehouse'].data.id
                ).attributes.code
              }}
            </td>
            <td :class="classes.td">
              {{
                getSingleIncluded(orders, order.relationships.order.data.id)
                  .attributes.area_name
              }}
            </td>
            <td :class="[classes.td, 'text-right']">
              {{
                getSingleIncluded(orders, order.relationships.order.data.id)
                  .attributes.grand_total_price | toCurrency
              }}
            </td>
            <td :class="[classes.td, 'text-center']">
              <base-badge color="indigo">{{
                order.attributes.warehouse_status
              }}</base-badge>
            </td>
          </tr>
        </template>
      </datatable>
    </div>

    <loading v-if="loading" />
  </base-wrapper>
</template>

<script>
import { requestMixin } from '@/mixins/request/request';
import { mapGetters } from 'vuex';

export default {
  mixins: [requestMixin],
  data() {
    return {
      filter: {
        status: 'Diproses Gudang Pengeluaran,Persiapan',
        search: null,
      },
      loading: false,
      orders: {
        data: [],
        meta: {
          page: {},
        },
      },
    };
  },
  computed: {
    ...mapGetters({
      me: 'auth/getUser',
    }),
  },
  methods: {
    async loadOrders(params) {
      this.loading = true;

      const [res, err] = await this.request('/api/v1/orders', {
        params: {
          'page[limit]': 5,
          'filter[order_type]': 'restock-loan',
          'filter[order_shipment]': 'pickup',
          'filter[origin_warehouse_id]': this.me.current_warehouse,
          'filter[warehouse_status]': this.filter.status,
          'filter[search]': this.filter.search,
          include:
            'destination-office,destination-warehouse,origin-warehouse,order',
          'fields[simple-orders]':
            'origin_code,updatedAt,warehouse_status,destination-office,destination-warehouse,origin-warehouse,order',
          'fields[offices]': 'code,name',
          'fields[warehouses]': 'code',
          'fields[orders]': 'area_name,grand_total_price',
          ...params,
        },
      });

      if (!err) {
        this.orders = res;
      }

      this.loading = false;
    },
    onPageChange(params) {
      this.loadOrders({
        ...params,
      });
    },
  },
  created() {
    this.loadOrders();
  },
};
</script>
